var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    fill: "none",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.548 5.318l.984-.984c.465-.465.48-1.025.034-1.483l-.444-.444c-.444-.458-1.025-.417-1.5.04l-.984.978 1.9 1.894zm-9.803 9.8l8.873-8.887-1.9-1.894-8.873 8.887-.738 2.024c-.15.403.26.766.615.636l2.023-.766z",
    fill: "currentColor"
  })));
}

export default SvgPencil;